import { Spin } from 'antd';
import React from 'react';

export interface ILoading {}

const Loading: React.FC<ILoading> = () => {
  return (
    <>
      <Spin />
    </>
  );
};

export default Loading;
